import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { app } from "../../../App";
import { navigateTo, PagePath } from "../../../helpers/PageHelper";
import Styles from "./AssetListView.module.scss";
import { PackModel } from "../../../stores/PackModel";
import AssetViewStakedPack from "../AssetViewStakedPack";
import { NoCardsView } from "../NoCardsView";

export const PacksListView = observer(() => {
	const packs = app.store.packs.queryAll()

	useEffect(() => {
		app.worldService.updatePackAndAsset();
	}, []);

	useEffect(() => {
		if (app.store.unpacking)
			navigateTo(PagePath.UNPACKING);
	}, [app.store.unpacking]);

	if (!packs.length) {
		return <NoCardsView />
	}

	const result = packs.map((item: PackModel) => {
		return <AssetViewStakedPack asset={item} key={`pack-${item.assetId}`}/>
	});

	return (
		<div className={Styles.stylePageViewsContainer}>
			{result}
		</div>
	)
})
